import { Title } from '../../components/Title'

export const Spec = () => {
    return (
        <>
            {' '}
            <div className='mx-auto relative mt-12'>
                <Title title='Informations' />
                <div className='flex flex-col pb-12 md:pb-20 font-kiwi text-shadow-white'>
                    <div className='max-w-[1200px] mx-auto'>
                        <div id='spec' className='mt-12 '>
                            <div className='container'>
                                <div>
                                    <table className='[&>tbody>tr>th]:pt-4 [&>tbody>tr>th]:md:pt-0 [&>tbody>tr]:flex-col [&>tbody>tr]:md:table-row [&>tbody>tr]:flex [&>tbody>tr]:items-center [&>tbody>tr>td]:table-cell [&>tbody>tr>td]:text-center [&>tbody>tr>td]:md:text-left table-auto text-center md:text-left mx-auto decoration-none text-sm md:text-base w-full px-4 xl:px-0 max-w-full font-bold'>
                                        <tbody>
                                            <tr className='w-full'>
                                                <th className='px-2  text-pborange'>Titre</th>
                                                <td className=' md:py-2 px-2 pl-4 md:pl-8 '>
                                                    Phantom Brave: The Lost Hero
                                                </td>
                                            </tr>
                                            <tr>
                                                <th className='px-2 text-pborange'>Sortie</th>
                                                <td className='md:py-2 px-2 text-left pl-4 md:pl-8 '>
                                                    {/* <h1 className=''>Sortie en 2025 ! </h1>{' '} */}
                                                    <h1 className=''>
                                                        Amérique du Nord :
                                                        <span className='whitespace-nowrap'> 30 janvier 2025</span>
                                                    </h1>
                                                    <h1 className=''>
                                                        Europe :
                                                        <span className='whitespace-nowrap'> 30 janvier 2025</span>
                                                    </h1>
                                                    <h1 className=''>ANZ : 7 février 2025</h1>
                                                    <h1 className=''>PC : 24 avril 2025 (Steam®)</h1>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th className='md:py-1 px-2  text-pborange'>Plateformes</th>
                                                <td className='md:py-2 px-2 text-left pl-4 md:pl-8  '>
                                                    Nintendo Switch&trade;, PS4®, PS5®, et Steam®
                                                    <br />
                                                </td>
                                            </tr>
                                            <tr>
                                                <th className='md:py-1 px-2  text-pborange'>Genre</th>
                                                <td className='md:py-2 px-2 text-left pl-4 md:pl-8 '>RPG Tactique</td>
                                            </tr>
                                            <tr>
                                                <th className='md:py-1 px-2  text-pborange'>Joueur</th>
                                                <td className='md:py-2 px-2 text-left pl-4 md:pl-8 '>1</td>
                                            </tr>
                                            <tr>
                                                <th className='md:py-1 px-2  text-pborange'>Langue</th>
                                                <td className='md:py-2 px-2 text-left pl-4 md:pl-8 '>
                                                    Français, Anglais
                                                </td>
                                            </tr>
                                            <tr>
                                                <th className='md:py-1 px-2  text-pborange'>Langue audio</th>
                                                <td className='md:py-2 px-2 pl-4 md:pl-8 '>Japonais, Anglais</td>
                                            </tr>
                                            <tr>
                                                <th className='md:py-1 px-2  text-pborange'>Développeur</th>
                                                <td className='md:py-2 px-2 pl-4 md:pl-8 '>
                                                    Nippon Ichi Software, Inc.
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
